import { useModal } from '@/hooks'
import {
  ResearchAreaGraphicsMap,
  ResearchAreaGraphicsMapProps,
} from '@/components/forms/ResearchAreaForm/ResearchAreaGraphicsMap'
import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import PreviewIcon from '@mui/icons-material/Preview'

export const PreviewResearchAreaGraphics = (
  researchAreaGraphicsMapProps: ResearchAreaGraphicsMapProps
) => {
  const { open } = useModal()
  const { t } = useTranslation('forms')

  return (
    <Button
      onClick={() =>
        open(
          <ResearchAreaGraphicsMap
            {...researchAreaGraphicsMapProps}
            readOnly={true}
          />
        )
      }
      startIcon={<PreviewIcon />}
      sx={{ height: '100%' }}
      variant="outlined"
    >
      {t('projectArea.viewArea')}
    </Button>
  )
}
